export const logError = (...arg) => {
    window.console.error(...arg);
};
export const logDebug = (...arg) => {
    window.console.debug(...arg);
};
